import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { TextInput } from '../../../../components/textInput/TextInput';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

export const SearchPlanes = ({
    rows = [],
    columns = [],
    value,
    totalCount,
    filterStatus,
    disabled,
    setFilterStatus,
    handleRowClick,
}) => {

    const [openModalBuscarCentro, setOpenModalBuscarCentro] = useState(false);

    const handleSearchCentro = () => setOpenModalBuscarCentro(true);

    const handleCloseSearchCentro = () => {
        setOpenModalBuscarCentro(false);
    }

    return (
        <>
            <TextInput
                label='Buscar Plan'
                onClick={handleSearchCentro}
                placeholder='Buscar'
                value={value}
                disabled={disabled}
                searchIcon
                sx={{ mt: 2.5 }}
            />
            <CustomDialog
                open={openModalBuscarCentro}
                maxWidth='md'
                fullWidth={true}
                title='Buscador de planes'
                onCancel={handleCloseSearchCentro}
            >
                <Grid
                    container
                    justifyContent={'space-between'}
                >
                    <Grid sx={{ my: 2.5 }} size={{ xs: 12, md: 6 }}>
                        <TextInput
                            placeholder='Filtrar'
                            value={filterStatus}
                            searchIcon
                            onChange={(e) => setFilterStatus(e.target.value)}
                            onClearButtonClick={() => setFilterStatus('')}
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <DataGridGenerico
                            hideFooterPagination={false}
                            toolbar={false}
                            columns={columns}
                            rows={rows}
                            totalCount={totalCount}
                            onRowClick={(row) => {
                                handleRowClick(row);
                                handleCloseSearchCentro()
                            }}
                        />
                    </Grid>
                </Grid>
            </CustomDialog>
        </>
    )
}